import Done from './Done';

const steps = [{
  id: 'done',
  screen: Done,
}];

export default steps;